export default __webpack_public_path__ + "static/media/original-9551c73edd32f9c2a822af1d1b7ea7b5.46842c75.gif";